/**
 * Example JavaScript singleton module
 */

var Menu = (function($) {
  function initMenu() {
    $("body").toggleClass("has-nav");
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".header-nav").length) {
      return;
    }

    $(".hamburger").click(function() {
      initMenu();
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Menu.init);
